import { Badge, Icon, IconButton, useToast } from "@stone-payments/jade";
import { type Product } from "@/actions/schemas/products";
import { useOrderResumeStore } from "@/stores";
import { cartAnalitica } from "@/app/(store)/_utils/events";

type Props = {
  product: Product;
  onAdd: (product: Product) => void;
};

export const ProductCardAddButton = ({ onAdd, product }: Props) => {
  const { addToast } = useToast();
  const { items, updateItem } = useOrderResumeStore();

  const hasVariants = product.variants?.length > 1;
  const cartItem = !hasVariants
    ? items.find((item) => item.id === product.variants?.[0].id)
    : undefined;

  const addToCart = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();

    cartAnalitica.events.action.addToCartByList("Adicionar");

    addToast({
      leading: <Icon color="on-color-high" size="large" use="cart-plus" />,
      text: `Boa escolha! ${product.name} foi adicionado ao carrinho.`,
    });

    onAdd(product);
  };

  const onIncrease = () => {
    if (!cartItem) return;

    updateItem({
      ...cartItem,
      quantity: cartItem.quantity + 1,
      price: {
        ...cartItem.price,
        subtotal: cartItem.price.sale * (cartItem.quantity + 1),
      },
    });
  };

  if (cartItem) {
    return (
      <div
        className="relative flex items-center"
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
        }}
      >
        <IconButton
          icon="cart"
          size="small"
          variant="primary-ghost"
          data-testid="product-card-add-button"
          onClick={onIncrease}
          className="bg-white!"
        />
        <span className="absolute -top-2 -right-2">
          <Badge label={cartItem.quantity} variant="text" voice="brand" />
        </span>
      </div>
    );
  }

  return (
    <div className="flex">
      <IconButton
        icon="cart-plus"
        size="small"
        variant="primary-solid"
        data-testid="product-card-add-button"
        onClick={addToCart}
      />
    </div>
  );
};
